<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
             Department of Agri Product Sale and Marketing/ Product Buy Vender
            
          </h2>
        </div>
      </div>

          <div class="columns scrollme" v-if="roleid==6 || roleid==7" style="min-height: 1000px;">
            <div class="column">
              <b-field>
                <b-field label="ປະເພດສິນຄ້າ">
                  <Multiselect
                    placeholder="ເລືອກ"
                    v-model.trim="selectedTypeSearch"
                    label="NAME"
                    track-by="ID"
                    :options="typeList"
                    @input="productTypeSelectedSearch"
                  >
                  </Multiselect>
                </b-field>
              </b-field>
        
              <b-field label="ລາຍການສິນຄ້າ">
                <table
                  class="table is-fullwidth is-narrow is-small"
                >
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="25%">
                        ຊື່ສິນຄ້າ
                      </th>
                      <th class="has-text-left " width="70%">
                        ຜູ້ສະໜອງ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in productBuyVenderList"
                      :key="data.PRODUCTID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.PRODUCTNAME }}
                      </td>
  
                      <td> 
                        <b-field>
                          <b-field v-for="item in data.PRODUCT_VENDER" :key="item.VENDERID"> 
                              
                              <b-button
                                class="is-small btn-group-margin"
                                type="is-danger"
                                size="is-small"
                                @click="removeProductVender(item.PRODUCTBUYVENDERID)"    
                            ><span style="font-size:16px">{{ item.VENDERNAME }} </span>
                            </b-button> 
                          </b-field> 

                          <b-field v-for="item in data.VENDER" :key="item.VENDERID">
                            <b-button
                              class="btn-group-margin"
                              type="is-success"  
                              size="is-small"
                              @click="addProductVender(data.PRODUCTID, item.VENDERID)"
                              ><span style="font-size:16px">{{ item.VENDERNAME  }}</span>
                            </b-button>
                          </b-field> 
                        </b-field>
                      </td>
                     
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },  
  props: ["MONTH"],
  data() {
    return {
    roleid: null,
    userName: null,
    productBuyVenderList: [],
    selectedTypeSearch: null,
    typeList: [],
    selectedTypeid: null,

    

    
  };
  },
  methods: {

    getProductTypes() {
      RestAPI.getVenderProductType()
        .then((res) => {
          // console.log("getProductTypes: " + JSON.stringify(res.data));
          this.typeList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    productTypeSelectedSearch() {
      if (this.selectedTypeSearch) {
        this.selectedTypeid = this.selectedTypeSearch.ID;
        this.getProductBuyVender();

      } else {
        this.getProducts();
      }
    },

    getProductBuyVender(){
      
      // console.log("typeid: " +typeid)
      const loadingComponent = this.$loading.open({});  
        RestAPI.getProductBuyVender(this.selectedTypeid) 
        .then((res) => {
          this.productBuyVenderList =  res.data.product;        
          loadingComponent.close();   
        })
        .catch((error) => {
          loadingComponent.close();
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
      });

      
    },

    removeProductVender(PRODUCTBUYVENDERID){
      // this.$swal({  
      //   title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
      //   showCancelButton: true,
      //   showCloseButton: true,
      //   confirmButtonText: "ຕ້ອງການ",
      //   cancelButtonText: "ບໍ່ຕ້ອງການ",  
      //   confirmButtonColor: "#d33",
      //   cancelButtonColor: "#3085d6",
      // }).then((result) => {
      //  if (result.value) {

          var params = {
            productbuyvenderid: PRODUCTBUYVENDERID,
            username: this.username,    
          };
          
        // console.log("params: "+JSON.stringify(params))  

         RestAPI.removeProductVender(params)   
           .then(() => {
            
             this.getProductBuyVender();

             this.$swal({
                title: "ສຳເລັດ",
                text: "ດຳເນີນການ ສຳເລັດ!",
                icon: "success",
                timer: 200,
                showConfirmButton: false, 
              });
            })
           .catch((error) => {
             console.log(error);
             if (error == "Error: Request failed with status code 400") {
               this.$swal("Check Input Data", "", "error");
             } else {
               this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
             }
         });
    //    }
    //  });
    },
    
    addProductVender(productid, venderid){
      // this.$swal({  
      //   title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
      //   showCancelButton: true,
      //   showCloseButton: true,
      //   confirmButtonText: "ຕ້ອງການ",
      //   cancelButtonText: "ບໍ່ຕ້ອງການ",  
      //   confirmButtonColor: "#d33",
      //   cancelButtonColor: "#3085d6",
      // }).then((result) => {
      //  if (result.value) {

          var params = {
            productid: productid,
            venderid: venderid,
            username: this.username,    
          };

          // console.log("params: "+JSON.stringify(params))  
          
         RestAPI.addProductVender(params)   
           .then(() => {
            
             this.getProductBuyVender();

             this.$swal({
                title: "ສຳເລັດ",
                text: "ດຳເນີນການ ສຳເລັດ!",
                icon: "success",
                timer: 200,
                showConfirmButton: false, 
              });
            })
           .catch((error) => {
             console.log(error);
             if (error == "Error: Request failed with status code 400") {
               this.$swal("Check Input Data", "", "error");
             } else {
               this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
             }
         });
    //    }
    //  });
    },
    
   
    print() {
      window.print();
    }
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.getProductTypes();
    
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
